import MenuEffect from "./MenuEffect";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import ActionUtility from "../../utilities/ActionUtility";
import { ReduxDispatch } from "../../models/ReduxProps";
import IStore from "../../models/IStore";
import MenuModel from "./models/MenuModel";

type ActionUnion = undefined | HttpErrorResponseModel | MenuModel[];

export default class MenuAction {
    public static readonly REQUEST_MENU_GET: string = "MenuAction.REQUEST_MENU_GET";
    public static readonly REQUEST_MENU_GET_FINISHED: string = "MenuAction.REQUEST_MENU_GET_FINISHED";

    public static readonly REQUEST_PATHS_GET: string = "MenuAction.REQUEST_PATHS_GET";
    public static readonly REQUEST_PATHS_GET_FINISHED: string = "MenuAction.REQUEST_PATHS_GET_FINISHED";

    public static menuGet(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            await ActionUtility.createThunkEffect<MenuModel[]>(
                dispatch,
                MenuAction.REQUEST_MENU_GET,
                MenuEffect.menuGet
            );
        };
    }

    public static pathsGet(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<any> => {
            return await ActionUtility.createThunkEffect<MenuModel[]>(
                dispatch,
                MenuAction.REQUEST_PATHS_GET,
                MenuEffect.menuGet
            );
        };
    }
}
